const formatNum = num => (num < 10 ? `0${num}` : num);

const msToTime = (timeLeft) => {

  // TimeLeft returned from API is in seconds
  let _seconds = 1;
  let _minutes = _seconds * 60;
  let _hours = _minutes * 60;

  let hours = Math.floor(timeLeft / _hours);
  let minutes = Math.floor((timeLeft % _hours) / _minutes);
  let seconds = Math.floor((timeLeft % _minutes) / _seconds);

  hours = formatNum(hours);
  minutes = formatNum(minutes);
  seconds = formatNum(seconds)

  return `${hours}:${minutes}:${seconds}`;

}

const toMoney = (price) => {
  // convert current bid in dollar format
  // amount divided by hundrend since it represent cents
  return (price / 100).toLocaleString("en-CA", { style: 'currency', currency: 'CAD' })
}

const uuid = () => {
  return (Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15))
}

// Convert Zulu datetime to local time
const DateTimeZuluToLocal = (datetime) => {
  return new Date(datetime).toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' })
}

// Convert Zulu datetime to local time
const DateTimeZuluToLocalShort = (datetime) => {
  return new Date(datetime).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' })
}

export default {
  msToTime,
  toMoney,
  uuid,
  DateTimeZuluToLocal,
  DateTimeZuluToLocalShort
}